import React, { useEffect, useState } from "react";
import axios from "axios";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';
import api from '../services/api';
import '../styles/styles.css'; 

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"];


export default function Dashboard() {
  //const [stats, setStats] = useState(null);
//const [stats, setStats] = useState({ users: {}, messages: {} });
const [stats, setStats] = useState({ users: {}, messages: {}, discussions: {} });
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const [error, setError] = useState(null);


  
useEffect(() => {
  api.get(`${API_URL}/api/stats`)
    .then(res => setStats(res.data))
    .catch(err => {
      console.error(err);
      if (err.response?.status === 403) {
        setError("Accès réservé aux administrateurs.");
      } else if (err.response?.status === 401) {
        setError("Vous devez être connecté pour voir cette page.");
      } else {
        setError("Erreur lors du chargement des statistiques.");
      }
    });
}, []);

if (error) return <p>{error}</p>;

  if (!stats) return <p>Chargement...</p>;

  return (
<div className="dashboard">
  <h1>Tableau de bord</h1>
  <div className="grid">
    <Card title="Utilisateurs totaux" value={stats.users.totalUsers} /> 
<Card title="Utilisateurs vérifiés" value={stats.users.verifiedUsers} /> 
<Card title="Connectés actuellement" value={stats.users.connectedUsers} /> 
<Card title="Invitations moyennes" value={stats.users.averagePendingInvites?.toFixed(2)} />
<Card title="Messages par non-vérifiés" value={stats.users.totalMessagesByUnverified} />

  </div>

  <div className="chart-container">
    <h2>Répartition des langues</h2>
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={stats.users.langStats?.map(l => ({ name: l._id || "inconnu", value: l.count }))}
          dataKey="value"
          label
        >
          {stats.users.langStats?.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  </div>
<div className="chart-container" style={{ marginTop: '1.5rem' }}>
  <h2>Utilisateurs non vérifiés</h2>
  {stats.users?.unverifiedUsers?.length > 0 ? (
    <table className="user-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Username</th>
          <th>Messages envoyés</th>
        </tr>
      </thead>
      <tbody>
        {stats.users.unverifiedUsers.map((user) => (
          <tr key={user.id}>
            <td>{user.id}</td>
            <td>{user.username}</td>
            <td>{user.messagesSent}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>Aucun utilisateur non vérifié.</p>
  )}
</div>

{/* ==== Cartes discussions ==== */}
<h2 style={{ marginTop: '2rem' }}>Stats discussions</h2>
<div className="grid">
  <Card title="Discussions totales" value={stats.discussions?.totalDiscussions} />
  <Card title="Publiques" value={stats.discussions?.publicDiscussions} />
  <Card title="Privées" value={stats.discussions?.privateDiscussions} />
  <Card title="Participants moyens" value={stats.discussions?.averageParticipants?.toFixed(2)} />
  <Card title="Actives (7 derniers jours)" value={stats.discussions?.activeDiscussions} />
</div>

<div className="chart-container" style={{ marginTop: '1.5rem' }}>
  <h2>Répartition par thème</h2>
  <ResponsiveContainer width="100%" height={300}>
    <PieChart>
      <Pie
        data={stats.discussions?.themeStats?.map(t => ({ name: t._id || "Privée (sans thème)", value: t.count })) || []}
        dataKey="value"
        label
      >
        {stats.discussions?.themeStats?.map((_, i) => (
          <Cell key={i} fill={COLORS[i % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  </ResponsiveContainer>
</div>
{/* ==== Cartes messages ==== */} 
<h2 style={{ marginTop: '2rem' }}>Stats messages</h2> 
<div className="grid"> 
<Card title="Messages totaux" value={stats.messages.totalMessages} /> 
<Card title="Messages avec fichiers" value={stats.messages.messagesWithFiles} /> 

</div>

{/* ==== Répartition des fichiers ==== */}
<div className="chart-container" style={{ marginTop: '1.5rem' }}>
  <h2>Répartition des fichiers envoyés</h2>
  <ResponsiveContainer width="100%" height={300}>
    <PieChart>
      <Pie
        data={stats.messages?.fileStats?.types?.filter(f => f.count > 0) || []}
        dataKey="count"
        nameKey="_id"
        label
      >
        {stats.messages?.fileStats?.types?.map((_, i) => (
          <Cell key={i} fill={COLORS[i % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  </ResponsiveContainer>
  <p style={{ textAlign: 'center', marginTop: '1rem' }}>
    <strong>Total fichiers :</strong> {stats.messages?.fileStats?.totalFiles}
  </p>
</div>
 {/* ==== Classement utilisateurs (bar chart) ==== */}
  <div className="chart-container" style={{ marginTop: '1.5rem' }}>

    <h2>Top 5 utilisateurs par messages envoyés</h2>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={stats.messages?.topUsers || []}>
  <CartesianGrid strokeDasharray="3 3" />
  <XAxis dataKey="username" />
  <YAxis />
  <Tooltip content={<CustomTooltip />} />
  <Legend />
  <Bar dataKey="count" name="Messages envoyés">
    {stats.messages?.topUsers?.map((user, index) => {
      let fillColor;
      switch (user.lang) {
        case 'fr':
          fillColor = '#2970b7'; // bleu
          break;
        case 'en':
          fillColor = '#f7230c'; // rouge
          break;
        case 'es':
          fillColor = '#FFBB28'; // jaune
          break;
	case 'de':
          fillColor = '#000000'; // jaune
          break;
	case 'it':
          fillColor = '#009246'; // vert
          break;
	case 'pt':
          fillColor = '#FF0000'; // rouge
          break;

        default:
          fillColor = '#FF8042'; // orange pour les autres
      }
      return <Cell key={index} fill={fillColor} />;
    })}
  </Bar>
</BarChart>

    </ResponsiveContainer>
  </div>
</div>
);
}

function Card({ title, value }) {
  return (
    <div className="card">
      <h3>{title}</h3>
      <p>{value}</p>
    </div>
  );
}
{/* ==== Tooltip personnalisé ==== */}
function CustomTooltip({ active, payload }) {
if (active && payload && payload.length) {
const data = payload[0].payload;
return (
<div
style={{
background: 'white',
padding: '10px',
border: '1px solid #ccc',
borderRadius: '8px',
boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
}}
> <p><strong>{data.username}</strong></p> <p>Messages : {data.count}</p>
{data.email && <p>Email : {data.email}</p>}
{data.lang && <p>Langue : {data.lang}</p>} </div>
);
}
return null;
}


